import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizAndItemAnalysis;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { withI18nSupport, withStyleOverrides } from '@instructure/quiz-common';
import Spinner from '../../../../common/components/shared/spinner/Spinner';
import Card from '../../../../common/components/shared/Card';
import FormattedDuration from '../../../../common/components/shared/FormattedDuration';
import ItemAnalysisRow from '../../../../reporting/components/itemAnalysis/ItemAnalysisRow';
import QuizAnalysisOverview from '../../../../reporting/components/quizAnalysis/QuizAnalysisOverview';
import MetricsListItem from '../../MetricsListItem';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var QuizAndItemAnalysis = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizAndItemAnalysis = /*#__PURE__*/function (_withI18nSupport) {
  function QuizAndItemAnalysis() {
    _classCallCheck(this, QuizAndItemAnalysis);
    return _callSuper(this, QuizAndItemAnalysis, arguments);
  }
  _inherits(QuizAndItemAnalysis, _withI18nSupport);
  return _createClass(QuizAndItemAnalysis, [{
    key: "getAnalyses",
    value: function getAnalyses(activeQuizId) {
      this.props.getExistingQuiz(activeQuizId);
      this.props.getItemAnalyses(activeQuizId);
      this.props.getQuizAnalysis(activeQuizId);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAnalyses(this.props.activeQuizId);
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.props.activeQuizId !== nextProps.activeQuizId) {
        this.getAnalyses(nextProps.activeQuizId);
      }
    }
  }, {
    key: "generateItemAnalysisMetrics",
    value: function generateItemAnalysisMetrics(itemAnalysis) {
      var _this2 = this;
      var metrics = [];
      var mean = t.rich('{score}<0>/{possible, number} pts</0>', {
        0: function _(_ref) {
          var children = _ref.children;
          return jsx("span", {
            key: "mean",
            css: _this2.props.styles.metricNote
          }, children);
        },
        score: itemAnalysis.meanScore(this.locale) || 0,
        possible: itemAnalysis.pointsPossible
      });
      this.props.itemMetrics.forEach(function (key) {
        switch (key) {
          case 'difficultyIndex':
            metrics.push(jsx(MetricsListItem, {
              key: "difficultyIndex",
              renderLabel: t('Difficulty Index'),
              renderValue: itemAnalysis.difficultyIndex(_this2.locale),
              customStyles: _this2.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'discriminationIndex':
            metrics.push(jsx(MetricsListItem, {
              key: "discriminationIndex",
              renderLabel: t('Discrimination Index'),
              renderValue: itemAnalysis.discriminationIndex(_this2.locale),
              customStyles: _this2.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'rpb':
            metrics.push(jsx(MetricsListItem, {
              key: "rpb",
              renderLabel: t('RPB'),
              renderValue: itemAnalysis.pointBiserial(_this2.locale),
              customStyles: _this2.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'meanEarnedScore':
            metrics.push(jsx(MetricsListItem, {
              key: "meanEarnedScore",
              renderLabel: t('Mean Earned Score'),
              renderValue: mean,
              customStyles: _this2.props.styles.metric,
              isGroupChild: true
            }));
            break;
        }
      });
      return metrics;
    }
  }, {
    key: "generateQuizAnalysisMetrics",
    value: function generateQuizAnalysisMetrics(quizAnalysis) {
      var _this3 = this;
      var metrics = [];
      var formattedElapsedTime = jsx(FormattedDuration, {
        seconds: quizAnalysis.meanElapsedTime()
      });
      this.props.quizMetrics.forEach(function (key) {
        switch (key) {
          case 'highScore':
            metrics.push(jsx(MetricsListItem, {
              key: "highScore",
              renderLabel: t('High Score'),
              renderValue: quizAnalysis.highScore(),
              customStyles: _this3.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'lowScore':
            metrics.push(jsx(MetricsListItem, {
              key: "lowScore",
              renderLabel: t('Low Score'),
              renderValue: quizAnalysis.lowScore(),
              customStyles: _this3.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'meanScore':
            metrics.push(jsx(MetricsListItem, {
              key: "meanScore",
              renderLabel: t('Mean Score'),
              renderValue: quizAnalysis.meanScore(),
              customStyles: _this3.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'standardDeviation':
            metrics.push(jsx(MetricsListItem, {
              key: "standardDeviation",
              renderLabel: t('Standard Deviation'),
              renderValue: quizAnalysis.standardDeviation(),
              customStyles: _this3.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'meanElapsedTime':
            metrics.push(jsx(MetricsListItem, {
              key: "meanElapsedTime",
              renderLabel: t('Mean Elapsed Time'),
              renderValue: formattedElapsedTime,
              customStyles: _this3.props.styles.metric,
              isGroupChild: true
            }));
            break;
          case 'cronbachsAlpha':
            metrics.push(jsx(MetricsListItem, {
              key: "cronbachsAlpha",
              renderLabel: t("Cronbach's Alpha"),
              renderValue: quizAnalysis.cronbachsAlpha(),
              customStyles: _this3.props.styles.metric,
              isGroupChild: true
            }));
            break;
        }
      });
      return metrics;
    }
  }, {
    key: "renderItemAnalysisRows",
    value: function renderItemAnalysisRows() {
      var _this4 = this;
      var _this$props = this.props,
        animateDelay = _this$props.animateDelay,
        animateDuration = _this$props.animateDuration,
        quiz = _this$props.quiz,
        openRows = _this$props.openRows,
        activeQuizId = _this$props.activeQuizId,
        toggleItemAnalysisRowExpanded = _this$props.toggleItemAnalysisRowExpanded;
      var itemAnalyses = quiz.getItemAnalyses();
      if (itemAnalyses.size <= 0) {
        return;
      }
      return jsx("div", null, jsx("div", {
        css: this.props.styles.title
      }, jsx(Heading, {
        level: "h3",
        as: "h2",
        color: "primary"
      }, t('Item Analysis'))), itemAnalyses.toArray().map(function (itemAnalysis, i) {
        var itemMetrics = _this4.generateItemAnalysisMetrics(itemAnalysis);
        return jsx(ItemAnalysisRow, {
          animateDelay: animateDelay,
          animateDuration: animateDuration,
          expanded: openRows[itemAnalysis.itemId],
          itemAnalysis: itemAnalysis,
          itemId: itemAnalysis.itemId,
          key: itemAnalysis.itemId,
          position: i + 1,
          quizId: activeQuizId,
          toggleExpanded: toggleItemAnalysisRowExpanded,
          outcomesEndpoint: _this4.props.outcomesEndpoint,
          outcomesToken: _this4.props.outcomesToken
        }, itemMetrics);
      }));
    }
  }, {
    key: "renderNotFound",
    value: function renderNotFound() {
      return jsx(Card, {
        css: this.props.styles.emptyText
      }, t('This report is no longer in use, please use the new Quiz and Item Analysis report.  ' + 'Reports generated before { lastReportDate } from this link will be available ' + 'until the summer of 2024. New reports cannot be generated from this link.', {
        lastReportDate: this.formatDateShort(new Date('2024-01-31'))
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props2 = this.props,
        animateDelay = _this$props2.animateDelay,
        animateDuration = _this$props2.animateDuration,
        quiz = _this$props2.quiz,
        quizAnalysis = _this$props2.quizAnalysis;
      var quizMetrics = this.generateQuizAnalysisMetrics(quizAnalysis);
      return jsx("div", {
        className: "fs-mask"
      }, jsx(QuizAnalysisOverview, {
        animateDelay: animateDelay,
        animateDuration: animateDuration,
        quizAnalysis: quizAnalysis,
        quizTitle: quiz.title
      }, quizMetrics), quizAnalysis.isPresent() && this.renderItemAnalysisRows());
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.quizAnalysisNotFound) {
        return this.renderNotFound();
      } else if (this.props.quiz.isLoaded() && this.props.quizAnalysis && this.props.quizAnalysis.isLoaded()) {
        return this.renderContent();
      } else {
        return jsx(Spinner, null);
      }
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_QuizAndItemAnalysis, "displayName", 'QuizAndItemAnalysis'), _defineProperty(_QuizAndItemAnalysis, "componentId", "Quizzes".concat(_QuizAndItemAnalysis.displayName)), _defineProperty(_QuizAndItemAnalysis, "propTypes", {
  animateDelay: PropTypes.number,
  animateDuration: PropTypes.number,
  activeQuizId: PropTypes.string.isRequired,
  openRows: PropTypes.objectOf(PropTypes.bool),
  outcomesEndpoint: PropTypes.string,
  outcomesToken: PropTypes.string,
  quiz: ImmutablePropTypes.record.isRequired,
  quizAnalysis: ImmutablePropTypes.record.isRequired,
  quizAnalysisNotFound: PropTypes.bool,
  quizMetrics: PropTypes.arrayOf(PropTypes.oneOf(['highScore', 'lowScore', 'meanScore', 'standardDeviation', 'meanElapsedTime', 'cronbachsAlpha'])),
  itemMetrics: PropTypes.arrayOf(PropTypes.oneOf(['difficultyIndex', 'discriminationIndex', 'rpb', 'meanEarnedScore'])),
  toggleItemAnalysisRowExpanded: PropTypes.func.isRequired,
  getExistingQuiz: PropTypes.func.isRequired,
  getItemAnalyses: PropTypes.func.isRequired,
  getQuizAnalysis: PropTypes.func.isRequired,
  locale: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_QuizAndItemAnalysis, "defaultProps", {
  animateDelay: void 0,
  animateDuration: void 0,
  openRows: {},
  outcomesEndpoint: null,
  outcomesToken: null,
  quizAnalysisNotFound: false,
  quizMetrics: [],
  itemMetrics: [],
  locale: null
}), _defineProperty(_QuizAndItemAnalysis, "contextTypes", {
  locale: PropTypes.string
}), _QuizAndItemAnalysis)) || _class);
export default QuizAndItemAnalysis;